import styled, { css } from 'styled-components';
import { colors, breakpoints } from '../../../../assets/styles/GlobalStyles';

// Rola por conta própria (altura fixa + overflow) — marcado pra rolarParaTopo
export const PageContainer = styled.div.attrs({ 'data-rolagem-pagina': true })`
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 300px;
    background: linear-gradient(135deg, ${colors.blueDark} 0%, ${colors.blueMedium} 100%);
    opacity: 0.05;
    pointer-events: none;
    z-index: 0;
  }
`;

export const Container = styled.div`
  padding: 120px 2rem 2rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 100px 1.5rem 1.5rem 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 90px 1rem 1rem 1rem;
  }
`;

export const Header = styled.div`
  margin-bottom: 2rem;
`;

export const Title = styled.h1`
  color: ${colors.darkBlue};
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  letter-spacing: -0.5px;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 1.5rem;
  }
`;

export const Subtitle = styled.p`
  color: ${colors.textMuted};
  font-size: 1rem;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.9rem;
  }
`;

export const StepsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 24px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${colors.lightGray};
    z-index: 0;
  }

  @media (max-width: ${breakpoints.mobile}) {
    gap: 0.5rem;

    &::before {
      top: 18px;
    }
  }
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
  flex: 1;

  @media (max-width: ${breakpoints.mobile}) {
    flex: 1 1 0;
    min-width: 0;
  }
`;

export const StepNumber = styled.div.attrs(props => ({
  style: {
    background: props.$active ? colors.darkBlue : props.$completed ? colors.lightBlue : colors.white,
    color: (props.$active || props.$completed) ? colors.white : colors.textMuted,
    borderColor: (props.$active || props.$completed) ? colors.darkBlue : colors.lightGray
  }
}))`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;

  @media (max-width: ${breakpoints.mobile}) {
    width: 36px;
    height: 36px;
    font-size: 1rem;
  }
`;

export const StepLabel = styled.span.attrs(props => ({
  style: {
    color: props.$active ? colors.darkBlue : colors.textMuted,
    fontWeight: props.$active ? 600 : 400
  }
}))`
  font-size: 0.85rem;
  text-align: center;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.72rem;
  }

  // Em telas estreitas não cabe o rótulo de todas as etapas: só a atual
  // mostra o nome (as outras ficam só com o número); nome longo vira reticências.
  @media (max-width: ${breakpoints.small}) {
    white-space: nowrap;
    max-width: 30vw;
    overflow: hidden;
    text-overflow: ellipsis;
    ${props => !props.$active && css`display: none;`}
  }
`;

export const FormSection = styled.div`
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid ${colors.borderLight};

  @media (max-width: ${breakpoints.mobile}) {
    padding: 1.1rem;
    border-radius: 12px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${colors.darkBlue};
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid ${colors.lightBlue};

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 1.05rem;
    margin-bottom: 1.1rem;
  }
`;


